import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export const uploadFile = async (file: File) => {
    const token = localStorage.getItem("token")
    
    const formData = new FormData()
    formData.append("file", file);

    const response = await axios.post(
        `${API_BASE_URL}/upload`,
        formData,
        {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            }
        }
    )

    console.log(response)

    return response
}